import Cookies from 'js-cookie';
import {
    getOrientation,
    getClientTimeOffset,
    getTimestamp,
    getTimestampInISO,
    getClientTimeOffsetInMilliseconds,
    getTimestampInMilliseconds
} from '../functions'
import env from '../env';

const PageLoad = {
    type: 'page_load',
    reloaded: new Boolean(performance.navigation.type === performance.navigation.TYPE_RELOAD),
    fromServerParameters: function(server) {
        return {
            type: this.type,
            data: [
                server.hash,
                server.language,
                server.subdomain,
                server.device,
                server.uuid,
                server.server_time,
                getClientTimeOffset(server.server_time),
                server.server_time_in_ms,
                getClientTimeOffsetInMilliseconds(server.server_time_in_ms),
                server.session_id,
                server.offer_url_id,
                server.country,
                server.flow,
                server.ext_id,
                server.result_token,
                server.page_number,
                this.reloaded,
            ]
        }
    }
}

const UserResult = {
    type: 'user_result',
    fromServerParameters: function(server) {
        console.debug(this, server);
        return {
            type: this.type,
            data: [
                server.server_time,
                server.server_time_in_ms,
                server.content_token,
                server.session_id,
                server.uuid,
                server.content_type,
                server.result_number,
                server.result_text,
                server.result_token,
            ]
        }
    },
}

const SessionData = {
    type: 'session_start',
    referer: '',
    userLanguage: navigator.language,
    resolution: `${window.screen.width * window.devicePixelRatio}x${window.screen.height * window.devicePixelRatio}`,
    orientation: getOrientation(),
    fromServerParameters: function (server) {
        return {
            type: this.type,
            data: [
                server.session_id,
                server.session_created,
                this.referer,
                server.browser_name,
                server.browser_version,
                this.userLanguage,
                server.os_name,
                server.os_version,
                server.device_model,
                this.resolution,
                this.orientation,
                server.country,
                server.offer_url_id,
                server.ext_id,
                server.content_token,
                server.flow,
                server.device,
            ]
        };
    }
}

const PageAdvance = {
    type: 'page_advance',
    fromServerParameters: function({ uuid, source }) {
        return {
            type: this.type,
            data: [
                uuid,
                getTimestamp(),
                getTimestampInMilliseconds(),
                window.focusTime,
                source,
            ]
        };
    }
}

const UserAnswer = {
    type: 'user_answer',
    fromServerParameters: function (server) {
        return {
            type: this.type,
            data: [
                server.server_time_human_readable,
                getTimestampInISO(),
                parseInt(server.server_time_in_ms),
                getTimestampInMilliseconds(),
                server.uuid,
                server.offer_url_id,
                server.country,
                server.device,
                server.session_id,
                server.content_token,
            ]
        }
    }
}

const BidsCollected = {
    type: 'bids_collected',
    fromServerParameters: function (server) {
        return {
            type: this.type,
            plain_data: true,
            data: [
                server.readable_timestamp,
                server.server_time_in_ms,
                server.uuid,
                server.session_id,
                server.offer_url_id,
                server.country,
                server.content_token,
                server.page,
                server.question_token,
            ]
        }
    }
}

const AdsLoaded = {
    type: 'ads_loaded',
    fromServerParameters: function () {
        return {
            type: this.type,
            data: []
        }
    }
}

const TaboolaSpend = {
    type: 'taboola_spend',
    fromServerParameters: function (server) {
        return {
            type: this.type,
            data: [
                server.server_time,
                parseInt(server.server_time_in_ms),
                server.session_id,
                server.partner_encrypt,
                server.country,
                server.offer_url_id,
                server.ext_id,
                server.device,
            ]
        }
    }
}

const Consent = {
    type: 'consent',
    fromServerParameters: function () {
        return {
            type: this.type,
            data: []
        }
    }
}

const AmazonBids = {
    type: 'amazonbids',
    fromServerParameters: function(server){
        return {
            type: this.type,
            data: [
                server.server_time_in_ms,
                server.uuid,
                server.offer_url_id,
                server.ext_id,
                server.session_id,
                server.country,
            ]
        }
    }
}

const HasOffersIneligible = {
    type: 'ho_conv_ineligible',
    fromServerParameters: function () {
        return {
            type: this.type,
            data: []
        }
    }
}

const Uci = {
    type: 'uci',
    fromServerParameters: function () {
        return {
            type: this.type,
            data: []
        }
    }
}

export { PageLoad, PageAdvance, SessionData, UserResult, UserAnswer, BidsCollected, AdsLoaded, TaboolaSpend, Consent, AmazonBids, HasOffersIneligible, Uci };
